module.exports = __webpack_public_path__ + "img/j_3.a79b12d3.jpg";